"use client";
import { useClerk, useUser } from "@clerk/nextjs";
import { IconLogout } from "@tabler/icons-react";

export default function SignOutButton() {
  const { signOut } = useClerk();
  const { user } = useUser();

  return (
    user && (
      <div
        className="my-4 flex cursor-pointer flex-col gap-2"
        onClick={() => signOut({ redirectUrl: "/" })}
      >
        <div className="flex flex-col gap-2">
          <IconLogout className="self-center text-lg" />
          <p className="my-0 text-sm font-normal">Sair</p>
        </div>
      </div>
    )
  );
}
